import ProfileActions from '../../../components/common/ProfileActions';
import { useBrandContext } from '../../../contexts/BrandContext';
import { PAGE_BRAND_PROFILE } from '../../../constants/UriConstants';

interface BrandProfileActionsProps {
  onSave?: () => void;
  submit?: boolean;
  isSaving?: boolean;
  isDisabled?: boolean;
}

const BrandProfileActions = ({ onSave, submit, isSaving, isDisabled }: BrandProfileActionsProps) => {
  const { currentBrand } = useBrandContext();

  return (
    <ProfileActions
      cancelTo={`/${currentBrand?.id}/${PAGE_BRAND_PROFILE}`}
      onSave={onSave}
      submit={submit}
      isSaving={isSaving}
      isDisabled={isDisabled}
    />
  );
};

export default BrandProfileActions;
